module.exports = __webpack_public_path__ + "img/banner.f47fb2e6.png";